import { Dispatch } from "react";
import jwtAxios from "../../utils/jwtAxios";
import { GET_CATEGORIES, UPDATE_CATEGORIES } from "../../types/actions/Category.actions";
import { AppActions } from "../../types/AppActions";
import { fetchError, showMessage } from "./Common";
import { Category } from "../../types/models/Category";
import { MakeCategory } from "../../types/models/MakeCategory";
import { AxiosResponseWithDetail } from "../../types";

export const makeCategory = (category: MakeCategory, callBack: (result: boolean, id: string | null) => void) => {

    return (dispatch: Dispatch<AppActions>) => {
      jwtAxios.post('/api/business/makecategory', category)
        .then((data: AxiosResponseWithDetail) => {
          if (data.status === 200) {
            const id = data.data.id;
            callBack(true, id);
          } else {
            dispatch(fetchError(
              data.detail
                ? data.detail
                : "Request failed. Status:" + data.status
            ));
            callBack(false, null);
          }
        })
        .catch((error) => {
          dispatch(fetchError(
            error.response.data.detail
              ? error.response.data.detail
              : error.message));
          callBack(false, null);
        });
    };
  };

  export const getCategories = (group_id: string, callBack: (categories: Category[] | undefined) => void) => {
    return (dispatch: Dispatch<AppActions>) => {
      jwtAxios
        .get("/api/business/listcategories?beacongroupid=" + group_id)
        .then((data) => {
          if (data.status === 200) {
            const categories = data.data;
            const customCategories: Category[] = categories.custom;
            dispatch({ type: GET_CATEGORIES, payload: customCategories});
            callBack(customCategories);
          } else {
            console.log("Failed here");
            dispatch(fetchError("Request failed. Status:" + data.status));
            callBack(undefined);
          }
        })
        .catch((error) => {
          dispatch(fetchError(
            error.response.data.detail
              ? error.response.data.detail
              : error.message));
          callBack(undefined);
        });
    };
  };

  export const uploadCategoryImage = (group_id: string, category_id: string,formData: FormData, uploadType: string, callback: (result: boolean) => void) => {
    return (dispatch: Dispatch<AppActions>) => {
  
      const config = {
        headers: {
            "Content-Type": "multipart/form-data"
        }
      };
      
      let url = "";
      switch(uploadType){
        case "ICON":
          url = "/api/business/categoryicon?beacongroupid=" + group_id + "&category_id=" + category_id;
          break;
        case "3D_MODEL":
          url = "/api/business/category3dmodel?beacongroupid=" + group_id + "&category_id=" + category_id;
          break;
        case "FILTER":
          url = "/api/business/uploadfilterlisticon?beacongroupid=" + group_id + "&category_id=" + category_id;
          break;
      }

      jwtAxios
        .post(url, formData, config)
        .then((data) => {
          if (data.status === 200) {
            callback(true);
          } else {
            dispatch(fetchError("Request failed. Status: " + data.status));
            callback(false);
          }
        })
        .catch((error) => {
          dispatch(fetchError(
            error.response.data.detail
              ? error.response.data.detail
              : error.message));
          callback(false);
        });
    };
  };

  export const deleteCategory = (beaconGroupId: string, categoryId: string, categoryName: string, callBack: (result: boolean) => void) => {

    return (dispatch: Dispatch<AppActions>) => {
      jwtAxios.post('/api/business/deletecategory', {
        BeaconGroupId: beaconGroupId,
        CategoryId: categoryId
      })
        .then((data: AxiosResponseWithDetail) => {
          if (data.status === 200) {
            dispatch(showMessage("Category " + categoryName + " has been deleted"));
            callBack(true);
          } else {
            dispatch(fetchError(
              data.detail
                ? data.detail
                : "Request failed. Status:" + data.status
            ));
            callBack(false);
          }
        })
        .catch((error) => {
          dispatch(fetchError(
            error.response.data.detail
              ? error.response.data.detail
              : error.message));
          callBack(false);
        });
    };
  };

  export const clearCategories = () => {
    return (dispatch: Dispatch<AppActions>) => {
      dispatch({ type: GET_CATEGORIES, payload: [] });
    };
  };

  export const UpdateCategories = (category: Category) => {
    return (dispatch: Dispatch<AppActions>) => {
      dispatch({ type: UPDATE_CATEGORIES, payload: category});
    };
  };